<template>
  <div style="position: relative">
    <div class="style-fullWidth">
      <div class="grid-container" style="font-size: 16px;">
        <!--    Cấp quy trình    -->
        <div class="item" v-if="isViewShareMode">
          <span class="title">Cấp quy trình:</span>
          <span class="font-size__small font_blued">{{ parentDeptName }}</span>
        </div>

        <!--    Tiêu đề    -->
        <div class="item">
          <span class="title">{{ getTitle }}:</span>
          <span class="font-size__small font_blued">{{ meetingTitle }}</span>
        </div>
        <div class="item" v-if="showMeetingContent && !isVinataba">
          <span class="title">Nội dung công việc:</span>
          <span class="font-size__small" style="white-space: pre-line;">{{ meetingContent }}</span>
        </div>

        <!--    Địa điểm    -->
        <div class="item" v-if="meetingPlace || isMeetingOnline">
          <span class="title">Địa điểm:</span>
          <span v-if="!isMeetingOnline" class="font-size__small font_blued">{{
              meetingPlaceLabel
            }}</span>
          <span
            v-else-if="!ableToJoinMeeting"
            class="font-size__small font_blued"
          >{{ meetingPlaceLabel }}</span
          >
          <el-tooltip v-else :content="'Tham gia cuộc họp'" placement="top">
            <a href="#" class="color__blue" @click.stop="joinRoom">
              {{ meetingPlaceLabel }}
              <i class="fas fa fa-sign-in font-size__small"></i>
            </a>
          </el-tooltip>
        </div>

        <!--    Thành phần tham dự, hiển thị trong trường hợp không phải vinataba    -->
        <div v-if="!isVinataba" class="item">
          <div class="title">Thành phần tham dự:</div>
          <div class="font-size__small">
            - Lãnh đạo:<span class="font_blued"> {{ leaderNames || "-" }} </span>
          </div>
          <div v-if="chairUnitDeptNames && chairUnitDeptNames.length" class="font-size__small">
            - Chủ trì: {{ chairUnitDeptNames ? chairUnitDeptNames.join(", ") : ""  }}
          </div>
          <div
            v-if="cooperateDeptNames && cooperateDeptNames.length"
            class="font-size__small"
          >
            - Phối hợp: {{ cooperateDeptNames ? cooperateDeptNames.join(", ") : "" }}
          </div>
          <div
            v-if="!!others"
            class="font-size__small"
          >
            - Thành phần khác: {{ others }}
          </div>
        </div>

        <!--    Lãnh đạo    -->
        <!--    Hiển thị đối với vinataba    -->
        <div v-if="leaderNames && leaderNames.length && isVinataba" class="item">
          <span class="title">Lãnh đạo:</span>
          <span class="font-size__small font_blued"> {{ leaderNames + (banLds ? ', ' + banLds : '') || "-" }} </span>
        </div>
      </div>

      <div class="grid-container">
        <!--    Nội dung công việc    -->
        <!--    Ẩn đối với vinataba    -->
<!--        <div class="item" v-if="showMeetingContent && !isVinataba">-->
<!--          <span class="title">Nội dung công việc:</span>-->
<!--          <span class="font-size__small">{{ meetingContent }}</span>-->
<!--        </div>-->

        <!--    Ghi chú    -->
        <!--    Ẩn đối với vinataba    -->
        <div class="item" v-if="otherInvolved  && !isVinataba">
          <span class="title">Ghi chú:</span>
          <span class="font-size__small" style="white-space: pre-line;">{{ otherInvolved }}</span>
        </div>

        <!--    File đính kèm    -->
        <!--    Ẩn đối với vinataba    -->
        <div class="item" v-if="vbAttachments && vbAttachments.length  && !isVinataba">
          <span class="title">File đính kèm</span>
          <br/>
          <div class="jobInfoAttachment">
            <div
              v-for="vbAttachment in vbAttachments"
              v-bind:key="vbAttachment.id"
              class="file-uploaded input-none__border"
            >
              <div class="file clickable flex-row flex__between padding-0">
                <a
                  class="flex-row flex__left margin-left-10"
                  @click.stop="downloadFile(vbAttachment)"
                >
                  <file-type-image
                    :fileExtention="vbAttachment.fileExtention"
                  />
                  <el-tooltip :content="vbAttachment.fileName" placement="top">
                    <span class="" :title="vbAttachment.fileName">{{
                        vbAttachment.fileName
                      }}</span>
                  </el-tooltip>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!--    Đơn vị chủ trì    -->
        <!--    Hiển thị đối với vinataba    -->
        <div v-if="chairUnitDeptNames && chairUnitDeptNames.length && isVinataba" class="item">
          <span class="title">Đơn vị chủ trì: </span>
          <span class="font-size__small font_blued">{{  chairUnitDeptNames.join(", ")  }}</span>
        </div>

        <!--    Đơn vị phối hợp    -->
        <!--    Hiển thị đối với vinataba    -->
        <div v-if="cooperateDeptNames && cooperateDeptNames.length && isVinataba" class="item">
          <span class="title">Đơn vị phối hợp: </span>
          <span class="font-size__small font_blued">
            {{ cooperateDeptNames.join(", ") }}
          </span>
        </div>

        <!--    Thành phần tham dự   -->
        <!--    Hiển thị đối với vinataba    -->
        <div v-if="participantNames.length > 0 && isVinataba" class="item">
          <span class="title">Thành phần tham dự: </span>
          <span class="font-size__small font_blued">{{ participantNames }}</span>
        </div>

        <!--    Thành phần    -->
        <!--    Hiển thị đối với vinataba    -->
        <div v-if="others && isVinataba" class="item">
          <span class="title">Thành phần: </span>
          <span class="font-size__small font_blued">{{ others }}</span>
        </div>

      </div>
    </div>
    <div class="sharedIconDiv" v-if="hcCaseMasterUser">
      <i class="cellIcon color__silver fas fa-user-circle"></i>
    </div>
  </div>
</template>

<script>
import attachmentService from "../../../services/attachmentService";
import FileTypeImage from "../../job/FileTypeImage";
import downloadService from "../../../services/downloadService";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import utils from "../../../services/utils";
import h from "../../../services/h";
import constants from "../../../constants";
import hcCaseCalendarUserViewService from "../../../services/hcCaseCalendarUserViewService";
import hcCaseMasterUserService from "../../../services/hcCaseMasterUserService";
import hcCaseCalendarService from "../../../services/hcCaseCalendarService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCfgMeetingRoomService from "../../../services/hcCfgMeetingRoomService";
import hcCaseCalendarParticipantViewService from "../../../services/hcCaseCalendarParticipantViewService";
import hcCaseCalendarBanLanhDaoService from "../../../services/hcCaseCalendarBanLanhDaoService";

export default {
  name: "fullCalendar-lichtuan-row",

  components: {FileTypeImage},
  props: [
    "meetingTitle",
    "meetingPlace",
    "chairUnitDeptNames",
    "cooperateDeptNames",
    "meetingContent",
    "otherInvolved",
    "caseMasterId",
    "hcCaseCalendarId",
    "groupFilters",
    "isViewShareMode",
    "parentDeptName",
    "hcCaseCalendarView",
    "showMeetingContent",
    "others",
    "isVinataba"
  ],

  data() {
    return {
      vbAttachments: [],
      leaders: [],
      banLds: '',
      participantNames: [],
      groups: [],
      leaderNames: null,
      hcCaseMasterUser: null,
      hcCfgMeetingRoom: null,
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isMeetingOnline() {
      return (
        this.hcCaseCalendarView.status === "HOANTHANH" &&
        this.hcCaseCalendarView &&
        (this.hcCaseCalendarView.meetingType ===
          constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE ||
          this.hcCaseCalendarView.meetingType ===
          constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH)
      );
    },

    ableToJoinMeeting() {
      return this.isMeetingOnline && this.hcCaseCalendarView.hcMeetingRoomId;
    },

    id() {
      return this.hcCaseCalendarView ? this.hcCaseCalendarView.id : null;
    },

    meetingPlaceLabel() {
      return hanhChinhUtils.getMeetingPlaceLabel(this.hcCaseCalendarView, this.hcCfgMeetingRoom);
    },

    getTitle() {
      let title = 'Tiêu đề'
      if (this.isVinataba) {
        title = 'Nội dung'
      }
      return title
    }
  },

  created() {
    this.loadVbAttachments();
    this.loadHcCfgMeetingRoom();
    this.loadLeaders()
      .then(() => this.initGroups())
      .then(() => this.initLeaderNames())
      .then(() => this.loadHcCaseMasterUser());
    if (this.isVinataba) {
      this.loadBanLds();
      this.getParticipantNames();
    }
  },

  methods: {

    loadHcCfgMeetingRoom() {
      return hcCfgMeetingRoomService
        .findById(this.hcCaseCalendarView.hcCfgMeetingRoomId)
        .then(response => (this.hcCfgMeetingRoom = response.data))
    },

    joinRoom() {
      return hcCaseCalendarService
        .joinRoom(this.id)
        .then(response => {
          window.open(response.data.urlWeb, "_blank");
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    loadHcCaseMasterUser() {
      return hcCaseMasterUserService
        .findByHcReferenceId(this.hcCaseCalendarId)
        .then(response => {
          this.hcCaseMasterUser = response.data;
        });
    },

    initLeaderNames() {
      let leaderNames = h.collect(this.groups, group => {
        switch (group.type) {
          case "item":
            return this.getLeaderName(group.data);
          case "group":
            return utils.getLabelForActorGroupFilter(group.filter);
        }
      });
      this.leaderNames = leaderNames ? leaderNames.join(", ") : null;
    },

    getLeaderName(leader) {
      let genderName =
        leader.gender === constants.USERS.GENDER.FEMALE ? "Bà" : "Ông";
      return `${genderName} ${leader.fullName}`;
    },

    initGroups() {
      this.groups = utils.groupActors(this.leaders, this.groupFilters);
    },


    loadLeaders() {
      return hcCaseCalendarUserViewService
        .findAllLanhDaoThamDu(this.caseMasterId)
        .then(response => (this.leaders = response.data));
    },

    loadBanLds() {
      return hcCaseCalendarBanLanhDaoService
        .findAllByHcCaseCalendarId(this.hcCaseCalendarId)
        .then(res => {
          const banLdArr = [];
          const banLdIds = h.collect(res.data, item => item.banLanhDaoCode);
          h.each(banLdIds, item => {
            switch (item) {
              case 'ldtct':
                banLdArr.push('Lãnh đạo TCT');
                break;
              case 'hdtv':
                banLdArr.push('Hội đồng thành viên');
                break;
              case 'btgd':
                banLdArr.push('Ban Tổng giám đốc');
                break;
            }
          });
          if (banLdArr.length > 0) this.banLds = banLdArr.join(', ');
        });
    },

    getParticipantNames() {
      return hcCaseCalendarParticipantViewService.findAllChiefsParticipate(this.caseMasterId)
        .then(res => {
          const participants = res.data;
          const names = h.collect(participants, item => {
            let genderName = item.gender === constants.USERS.GENDER.FEMALE ? "Bà" : "Ông";
            return `${genderName} ${item.fullName}`;
          });
          this.participantNames = names ? names.join(", ") : null;
        })
    },

    loadVbAttachments() {
      return attachmentService
        .findAllByHcCalendar(this.caseMasterId)
        .then(response => (this.vbAttachments = response.data));
    },

    downloadFile(vbAttachment) {
      return downloadService
        .downloadHcCaseCalendarAttachment(
          this.hcCaseCalendarId,
          vbAttachment.id
        )
        .catch(error => {
          this.notify(
            "Thông báo",
            errorMessageFilter({
              errorCode: "hcLichTuan.canNotDownloadAttachment"
            }),
            "error",
            2000
          );
          throw error;
        });
    }
  }
};
</script>

<style scoped>
.grid-container {
  display: grid;
  overflow: hidden;
  width: 45%;
  float: left;
  grid-template-columns: auto;
  grid-gap: 5px;
}

.grid-container:last-child {
  width: 55%;
}

.grid-container > .item {
  font-size: var(--font-small);
  padding-right: 10px;
}

.grid-container:first-child > .item {
  padding-left: 10px;
}

.grid-container > .item > .title {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
}

.grid-container > .item > .font-size__small {
  font-size: 13px;
  line-height: 20px;
}

.fc-widget-header {
  background: var(--color-dark) !important;
}

.fc-widget-header > span {
  color: white;
}

.font_blued {
  color: var(--color-blue);
}

.leftSection {
  width: 100%;
}

.sharedIconDiv {
  position: absolute;
  right: 10px;
}

.sharedIconDiv i {
  font-size: x-large !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/fullCalendar-lichtuan-row.vue